import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface Appointment {
  name: string;
  time: string;
  type: string;
  color: string;
}

const generatePatientScheduleContent = (lang: 'en' | 'de'): string => {
  const isEnglish = lang === 'en';

  const appointments: Appointment[] = [
    {
      name: isEnglish ? 'John Smith' : 'Johannes Schmidt',
      time: isEnglish ? '09:00 AM' : '09:00 Uhr',
      type: isEnglish ? 'Checkup' : 'Untersuchung',
      color: '#10b981',
    },
    {
      name: isEnglish ? 'Maria Garcia' : 'Maria Fischer',
      time: isEnglish ? '10:30 AM' : '10:30 Uhr',
      type: isEnglish ? 'Urgent' : 'Dringend',
      color: '#ef4444',
    },
    {
      name: isEnglish ? 'Robert Johnson' : 'Robert Jung',
      time: isEnglish ? '01:15 PM' : '13:15 Uhr',
      type: isEnglish ? 'Follow-up' : 'Nachuntersuchung',
      color: '#434ce8',
    },
  ];

  return `
    <div style="display: flex; flex-direction: column; height: 100%;">
      <div style="margin-bottom: 10px; font-weight: 600; color: #282a32;">
        ${isEnglish ? "Today's Appointments" : 'Heutige Termine'}
      </div>
      ${appointments
        .map(
          appointment => `
        <div style="display: flex; justify-content: space-between; margin-bottom: 8px; padding: 10px; background-color: #fdfcff; border-radius: 8px; border: 1px solid #eff1f6;">
          <div style="font-weight: 500;">${appointment.name}</div>
          <div style="color: #686b87;">${appointment.time}</div>
          <div style="color: ${appointment.color}; font-weight: 500;">${appointment.type}</div>
        </div>`,
        )
        .join('')}
    </div>`;
};

export const patientScheduleWidget: MultilingualWidgetConfig = {
  id: 'patient-schedule',
  translations: {
    en: {
      title: 'Patient Schedule',
      content: generatePatientScheduleContent('en'),
    },
    de: {
      title: 'Patientenplan',
      content: generatePatientScheduleContent('de'),
    },
  },
  x: 0,
  y: 0,
  w: 2,
  h: 2,
};
